import { getDetailsTabRoutes, getDetailsTabRouteObjects, getSelectableResult, getModuleChildOfOrEqualDetails } from "../../../utility/route";

export const userListLDTRoutes = getDetailsTabRoutes('users', 'user_id');
export const externalUserListLDTRoutes = getDetailsTabRoutes('externalusers', 'external_user_id');
export const identitiesLDTRoutes = getDetailsTabRoutes('identities', 'invoice_project_id');
export const noticesLDTRoutes = getDetailsTabRoutes('notices', 'client_notice_id');

export const getUserDetailsSelectable = getSelectableResult(userListLDTRoutes);
export const getExternalUserDetailsSelectable = getSelectableResult(externalUserListLDTRoutes);
export const getInvoiceProjectDetailsSelectable = getSelectableResult(identitiesLDTRoutes);

// export const getInvoiceReminderDetailsSelectable = getSelectableResult(invoiceReminderListLDTRoutes);

export const moduleRoutes = [
  userListLDTRoutes,
  identitiesLDTRoutes,
  noticesLDTRoutes,
  externalUserListLDTRoutes
];

// const detailsRoutes = moduleRoutes.map(m => m.names.details);

// export const childOfOrEqualDetails = route => {
//   return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
// }

export const childOfOrEqualDetails = getModuleChildOfOrEqualDetails(moduleRoutes);
